











































































import { Component, Ref, Vue } from "vue-property-decorator";
import { NotificationState } from "@/store/modules/notification";
import catalogService from "@/service/catalogService";
import CatalogDeleteDialog from "@/components/organisms/catalog/CatalogDeleteDialog.vue";
import CatalogEditDialog from "@/components/organisms/catalog/CatalogEditDialog.vue";
import CatalogCsvUploadDialog from "@/components/organisms/catalog/CatalogCsvUploadDialog.vue";
import { Catalog } from "@/graphql/client";

@Component({
  components: {
    CatalogDeleteDialog,
    CatalogEditDialog,
    CatalogCsvUploadDialog,
  },
})
export default class CatalogList extends Vue {
  @Ref() readonly editDialog!: CatalogEditDialog;
  @Ref() readonly deleteDialog!: CatalogDeleteDialog;
  @Ref() readonly uploadDialog!: CatalogCsvUploadDialog;
  //---------------------------
  // data
  //---------------------------
  items: Catalog[] = [];
  headers = [
    {
      text: "コード",
      value: "code",
      width: "15%",
    },
    {
      text: "名称",
      value: "name",
    },
    {
      text: "",
      value: "editAction",
      width: "30px",
      sortable: false,
    },
    {
      text: "",
      value: "deleteAction",
      width: "30px",
      sortable: false,
    },
  ];

  searchKeyword = "";
  loadingDataGrid = false;
  //---------------------------
  // mounted
  //---------------------------
  mounted(): void {
    this.fetchData();
  }

  //---------------------------
  // computed
  //---------------------------
  //---------------------------
  // methods
  //---------------------------
  async fetchData(): Promise<void> {
    this.loadingDataGrid = true;
    catalogService.allCatalogs().then((items) => {
      this.items = items;
      this.loadingDataGrid = false;
    });
  }
  /**
   * カタログマスタをダウンロードします.
   */
  public async exportCSV(): Promise<void> {
    await catalogService.exportCSV();
  }

  /**
   * カタログマスタCSVアップロードダイアログを表示します.
   */
  public openUploadDialog(): void {
    this.uploadDialog.open();
  }
  /**
   * カタログマスタアップロードダイアログの処理成功時.
   */
  public async onUploadSuccess(value: string): Promise<void> {
    //一覧再取得
    await this.fetchData();
    this.uploadDialog.close();
    NotificationState.notifySuccess("カタログマスタを更新しました！");
  }

  /**
   * カタログマスタ編集ダイアログ（新規追加）を表示します.
   */
  public openCreateDialog(): void {
    this.editDialog.open(catalogService.defaultCatalog);
  }

  /**
   * カタログマスタ編集ダイアログを表示します.
   */
  public openEditDialog(item: Catalog): void {
    this.editDialog.open(item);
  }

  /**
   * カタログマスタ編集ダイアログの更新成功時.
   */
  public onUpdateSuccess(updated: Catalog): void {
    //一覧にも反映
    const index = this.items.findIndex((el) => {
      return el.guid === updated.guid;
    });
    if (index > -1) {
      this.items.splice(index, 1, updated);
    }

    this.editDialog.close();
    NotificationState.notifySuccess("カタログマスタを更新しました！");
  }

  /**
   * カタログマスタ編集ダイアログの登録成功時.
   */
  public onCreateSuccess(created: Catalog): void {
    //一覧にも追加
    this.items.unshift(created);

    this.editDialog.close();
    NotificationState.notifySuccess("カタログマスタを登録しました！");
  }

  /**
   * カタログマスタ削除ダイアログを表示します.
   */
  public openDeleteDialog(item: Catalog): void {
    this.deleteDialog.open(item);
  }

  /**
   * カタログマスタ削除ダイアログの処理成功時.
   */
  public onDeleteSuccess(deleted: Catalog): void {
    //一覧からも削除
    const newItems = this.items.filter((item) => item.guid !== deleted.guid);
    this.items = newItems;

    this.deleteDialog.close();
    NotificationState.notifySuccess("カタログマスタを削除しました！");
  }
}
